import AttendanceAdapter from './base';

export default class DayCode extends AttendanceAdapter {
  modelNamePlural = 'dayCodes';
}
